export default __webpack_public_path__ + "CircularCustCapNum-LightItalic.61911d87788a1ba4268b079e33f97a13.woff";